import { render, staticRenderFns } from "./NewOuterHeader.vue?vue&type=template&id=5f981b59"
import script from "./NewOuterHeader.vue?vue&type=script&lang=js"
export * from "./NewOuterHeader.vue?vue&type=script&lang=js"
import style0 from "./NewOuterHeader.vue?vue&type=style&index=0&id=5f981b59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports